<ui-dialog
    #addNoteDialog
    formDialog
    primaryButtonLabel="save"
    secondaryButtonLabel="cancel"
    size="small"
    [header]="!review.note ? 'performance.show.addNote' : 'performance.show.editNote'"
    (primaryButtonPressed)="saveNote()"
    [open]="noteDialogIsOpen"
    (closing)="noteDialogIsOpen = false"
    (onSecondaryButtonPressed)="noteDialogIsOpen = false"
>
    <app-review-note-form #reviewNoteForm [review]="review"></app-review-note-form>
</ui-dialog>

<div class="ui segment">
    <app-segment-header
        [createPermission]="!userHasNoteModificationPermission ? 'never' : ''"
        title="performance.show.note"
        [createLabel]="!review.note ? 'performance.show.addNote' : 'performance.show.editNote'"
        (create)="addNote()"
    ></app-segment-header>
    <p *ngIf="!review.note">{{ 'performance.show.noNoteExists' | translate }}</p>
    <pre class="formattedNote">{{ review.note }}</pre>
</div>
